import { z } from "zod";

export const authForgotPasswordInputZodSchema = z.object({
	email: z.string().email(),
});

export type AuthForgotPasswordInputType = z.infer<typeof authForgotPasswordInputZodSchema>;
